import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SharedModule } from 'src/app/shared/shared.module';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { LayoutRoutingModule } from 'src/app/layout/layout-routing.module';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { FooterModule } from './footer/footer.module';
import { DynamicFormModule } from 'src/app/components/dynamic-form/dynamic-form.module';
import { PathToLiveWorkflowModule } from 'src/app/main/service/path-to-live-workflow/path-to-live-workflow.module';
import { HelpCenterModule } from './help-center/help-center.module';
import { FaqSupportButtonsModule } from 'src/app/components/faq-support-buttons/faq-support-buttons.module';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    LayoutComponent
  ],
  imports: [
    LayoutRoutingModule,

    CommonModule,
    SharedModule,

    ToolbarModule,
    FooterModule,

    RouterModule,
    MatSidenavModule,

    DynamicFormModule,
    PathToLiveWorkflowModule,
    HelpCenterModule,
    FaqSupportButtonsModule,
    MatIconModule
  ]
})
export class LayoutModule { }
